import { Metamodel } from 'app/model/base/model';
import { SharePointOnlineFileLinkedService } from 'app/model/linkedservice/sharepoint-online-file.linkedservice';
import { AdvancedStoreWriteSettings } from './advanced-store-write-settings';

@Metamodel.model({
    name: 'SharePointOnlineFileWriteSettings',
    tags: {
        linkedServiceModel: Metamodel.modelFor(SharePointOnlineFileLinkedService)
    }
})
export class SharePointOnlineFileWriteSettings extends AdvancedStoreWriteSettings {
}
